import QRCode from 'qrcode';

export async function qrDataUrl(text: string): Promise<string> {
  return QRCode.toDataURL(text, { margin: 1, width: 336, color: { dark: '#1f2328', light: '#ffffff' } });
}
